export type PromotionExpirationExcelTemplate = {
    AGREEMENTNUMBER: string | null,
    CONTROLNUMBER: string | null,

    CUSTOMERID: string | null,
    CUSTOMERNAME: string | null,
    CUSTOMERADDRESS: string | null,

    SEGMENT: string | null,
    SEGMENTDESC: string | null,
    CHANNEL: string | null,
    CHANNELDESC: string | null,
    TIER: string | null,
    TIERDESC: string | null,
    BUYINGGROUP: string | null,
    BUYINGGROUPDESC: string | null,
    CORPORATEAFFILIATION: string | null,
    CORPORATEAFFILIATIONDESC: string | null,
    COUNTRYCODE: string | null,
    COUNTRYDESC: string | null,
    PRICEZONE: string | null,
    PRICEZONEDESC: string | null,
    FREIGHTZONE: string | null,

    PRODUCTLINE: string | null,
    PRODUCTLINEDESC: string | null,

    PRODUCTCATEGORY: string | null,
    PRODUCTCATEGORYDESC: string | null,

    ITEMNUMBER: string | null,
    ITEMDESC: string | null,
    MANUFACTURERSNUMBER: string | null,
    GTIN: string | null,

    SUPPLIERFLAG: string | null,
    JOBTYPE: string | null,
    JOBTYPEDESC: string | null,
    EMPLOYEERESPONSIBLEPRICING: string | null,

    PROMOTIONID: string | null,
    PROMOTIONIDDESC: string | null,
    PROMOTIONAMOUNT: string | null,
    UOM: string | null,
    PROMOTIONPERCENT: string | null,

    MINIMUMCODE: string | null,
    MINIMUMDESC: string | null,
    MINIMUMVALUE: string | null,

    MAXCODE: string | null,
    MAXIMUMDESC: string | null,
    MAXIMUMVALUE: string | null,
    
    BEGINORDERDATE: string | null,
    ENDORDERDATE: string | null,
    EXTENDORDERENDDATE: string | null,

    BEGINDELIVERYDATE: string | null,
    ENDDELIVERYDATE: string | null,
    EXTENDDELIVERYENDDATE: string | null,

    CONTACTEMAIL: string | null,
    "EXTEND/DELETE/CANCEL/NEW": string | null,

    NEWPROMOTIONAMOUNT: string | null,
    NEWPROMOTIONUOM: string | null,
    NEWBEGINNINGORDERDATE: string | null,
    NEWENDINGORDERDATE: string | null,
    NEWBEGINNINGDELIVERYDATE: string | null,
    NEWENDINGDELIVERYDATE: string | null,

    COMMENTS: string | null,
}

export const PromotionExpirationExcelTemplate_Default = {
    AGREEMENTNUMBER: "",
    CONTROLNUMBER: "",

    CUSTOMERID: "",
    CUSTOMERNAME: "",
    CUSTOMERADDRESS: "",

    SEGMENT: "",
    SEGMENTDESC: "",
    CHANNEL: "",
    CHANNELDESC: "",
    TIER: "",
    TIERDESC: "",
    BUYINGGROUP: "",
    BUYINGGROUPDESC: "",
    CORPORATEAFFILIATION: "",
    CORPORATEAFFILIATIONDESC: "",
    COUNTRYCODE: "",
    COUNTRYDESC: "",
    PRICEZONE: "",
    PRICEZONEDESC: "",
    FREIGHTZONE: "",

    PRODUCTLINE: "",
    PRODUCTLINEDESC: "",

    PRODUCTCATEGORY: "",
    PRODUCTCATEGORYDESC: "",

    ITEMNUMBER: "",
    ITEMDESC: "",
    MANUFACTURERSNUMBER: "",
    GTIN: "",

    SUPPLIERFLAG: "",
    JOBTYPE: "",
    JOBTYPEDESC: "",
    EMPLOYEERESPONSIBLEPRICING: "",

    PROMOTIONID: "",
    PROMOTIONIDDESC: "",
    PROMOTIONAMOUNT: "0",
    UOM: "",
    PROMOTIONPERCENT: "0",

    MINIMUMVALUE: "",
    MINIMUMCODE: "",
    MINIMUMDESC: "",

    MAXIMUMVALUE: "",
    MAXCODE: "",
    MAXIMUMDESC: "",
    
    BEGINORDERDATE: "",
    ENDORDERDATE: "",
    EXTENDORDERENDDATE: "",

    BEGINDELIVERYDATE: "",
    ENDDELIVERYDATE: "",
    EXTENDDELIVERYENDDATE: "",

    CONTACTEMAIL: "",
    "EXTEND/DELETE/CANCEL/NEW": null,

    NEWPROMOTIONAMOUNT: "0",
    NEWPROMOTIONUOM: "",
    NEWBEGINNINGORDERDATE: "",
    NEWENDINGORDERDATE: "",
    NEWBEGINNINGDELIVERYDATE: "",
    NEWENDINGDELIVERYDATE: "",

    COMMENTS: ""
} as PromotionExpirationExcelTemplate;
